import { render, staticRenderFns } from "./BackBar.vue?vue&type=template&id=8b98e110&scoped=true&"
import script from "./BackBar.vue?vue&type=script&lang=ts&"
export * from "./BackBar.vue?vue&type=script&lang=ts&"
import style0 from "./BackBar.vue?vue&type=style&index=0&id=8b98e110&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b98e110",
  null
  
)

export default component.exports